export const JobOpportunityQuestionAnswerType = [
  "TEXT",
  "SINGLE_CHOICE",
  "MULTIPLE_CHOICE",
  "BOOLEAN",
  "NUMBER",
  "DATE",
  "DATETIME",
  "TIME",
];

export const JobOpportunityQuestionAnswerValueType = [
  "TEXT",
  "MULTILINE_TEXT",
  "NUMBER",
  "URL",
  "EMAIL",
  "PHONE",
  "DATE",
  "DATETIME",
  "TIME",
  "BOOLEAN",
];

export const CHOICE_ANSWER_TYPES = ["SINGLE_CHOICE", "MULTIPLE_CHOICE"];
